var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page login-page section-image"},[_c('div',{staticClass:"full-page-background",style:(_vm.loginBackground())})])])])}
var staticRenderFns = []

export { render, staticRenderFns }